<template>
  <v-container fluid class="px-10 py-4">
    <template v-slot:after-heading> </template>
    <v-row class="d-flex justify-space-between mx-1 mb-0">
      

      <v-col cols="3" md="3">
        <v-btn @click="goBack" class="primary">
          <i class="mdi mdi-arrow-left-bold"></i>返回
        </v-btn>
        <v-btn @click='pickFile' color="orange" class="mx-3">
          上传文件
          <v-icon right>mdi-upload</v-icon>
        </v-btn>
        <template>
          <input
            type="file"
            style="display: none"
            ref="image"
            accept="*"
            @change="onFilePicked"
          >
</template>
      </v-col>
    </v-row>


    <v-alert
      :value="alert"
      color="red"
      dark
      border="top"
      icon="mdi-bell"
      transition="scale-transition"
    >
      {{ alert_text }}
    </v-alert>
    <v-card class="ma-3 pa-6">
      <div  class="ml-6">
        <div id="printMe" class="print-magin">
          <h1 class="ma-3" style="color: rgb(247, 142, 45) !important;">
            {{ details.garden_name }}
          </h1>
          <div>
            <span class="ma-3">
              施工时间：
              <span class="ma-3"
                >{{ details.construction_time }}，</span
              >
            </span>
            <span class="ma-3"
              ><span class="noprint">竣工时间：</span>
              {{ details.completed_time }}，</span
            >
            <span class="ma-3"
              ><span class="noprint">拟交付时间：</span>
              {{ details.expected_time }}，</span
            >
            <span class="ma-3"
              >交房时间：{{ details.delivery_time }}</span
            >
            
          </div>
          <br />
          <div>
            <span class="ma-3">
              项目总投资（亿元）：
              <span class="ma-3"
                >{{ details.invest_fee }}，</span
              >
            </span>
            <span class="ma-3"
              ><span class="noprint">其中土地成本(亿元)：</span>
              {{ details.land_fee }}，</span
            >
            <span class="ma-3 printstyle"
              ><span class="noprint">建安成本（亿元）：</span>
              {{ details.construction_fee }}，</span
            >
            <span class="ma-3 printstyle noprint"
              >其他费用（加成10%+9%税金）（亿元）：{{ details.other_fee }}</span
            >
            </div>
            <br />
            <div>
            <span class="ma-3 printstyle noprint"
              >银行贷款情况（贷款金额）（亿元）：{{ details.loan_fee }}</span
            >
            <span class="ma-3 printstyle noprint"
              >贷款利率（亿元）：{{ details.loan_rate }}</span
            >
            <span class="ma-3 printstyle noprint"
              >建设期利息（亿元）：{{ details.construction_interest }}</span
            >
            
          </div>
          <br />
          <div>
            <span class="ma-3 printstyle noprint">还款周期（年限及还本期）：{{ details.repayment }}</span>
          </div>
          <br />
          <div>
            
            <span class="ma-3">可销售面积（万平方米）：{{details.sale_area }}，</span>
            <span class="ma-3">可售面积建设成本单价（万元每平米）：{{ details.sale_price }}，</span>
            <span class="ma-3">每平方加成、税金成本（万元每平米）：{{ details.taxes_fee }}，</span>
            <span class="ma-3">含代建费+税费的单价（万元每平米）：{{ details.tax_price }}</span>
            
          </div>
          <br />
          <div>
            <span class="ma-3">总套数：{{ details.totals }}，</span>
            <span class="ma-3">大 | 中 | 小 ：{{ details.large }} | {{ details.middle }} | {{ details.small }}，</span>
            <span class="ma-3">总可售面积（万平方米）：{{details.total_area }}，</span>
          </div>
          <br />
          <div>
            
            <span class="ma-3">大平台已选套数（套）：{{details.dpt_count }}，</span>
            <span class="ma-3">已选平方（万平方米）：{{details.dpt_area }}，</span>
            <span class="ma-3">预计大平台缴纳（亿元）：{{details.dpt_fee }}，</span>
          </div>
          <br />
          <div>
            <span class="ma-3">农房集聚已选套数（套）：{{details.nfjj_count }}，</span>
            <span class="ma-3">已选平方（万平方米）：{{details.nfjj_area }}，</span>
            <span class="ma-3">预计农房集聚缴纳（亿元）：{{details.nfjj_fee }}，</span>
          </div>
          <br />
          <div>
            <span class="ma-3">空置房（套）：{{details.empty_count }}，</span>
            <span class="ma-3">空置面积（万平方米）：{{details.empty_area }}，</span>
            <span class="ma-3">空置房缴纳（亿元）：{{details.empty_fee }}，</span>
          </div>
          <br />
          <div>
            <span class="ma-3">施工单位：{{details.construction_unit }}，</span>
            <span class="ma-3">建设单位：{{ details.construct_unit }}，</span>
            <span class="ma-3">监理单位：{{ details.supervision_unit }}，</span>
            <span class="ma-3">设计单位：{{ details.design_unit }}</span>
            <span class="ma-3">勘察单位：{{ details.survey_unit }}</span>
          </div>
          <br>
 
        </div>
        
      </div>

      <v-divider class="my-6"></v-divider>
  
    <v-simple-table fixed-header class="mytable">
      <template v-slot:default>
        <thead>
          <tr>
            <th width="50"></th>
            <th width="500" class="text-left">文件名称</th>
            <th width="200"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, i) in files_list" :key="i">
            <td class="text-center">
              {{ i + 1 }}
            </td>
            <td class="text-left">
             <a :href="row.fileurl" target="_blank" style="color: #fff;text-decoration: none;">{{ row.filename }} </a> 
             
            </td>
            <td class="total_fee">
              
              <v-btn color="red" icon @click="removeFile(row.id)">
                <v-icon left>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- <div class="text-center">
      <v-row justify="center" align="center">
        <v-pagination
          v-model="listQuery.page"
          :circle="circle"
          :disabled="disabled"
          :length="total_pages"
          :next-icon="nextIcon"
          :prev-icon="prevIcon"
          :total-visible="totalVisible"
          :value="listQuery.page"
          @input="paginationChangeHandler"
        ></v-pagination>
        <span>共{{total_pages}}页</span>
      </v-row>
    </div> -->
    </v-card>

    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
    </v-snackbar>
  
  </v-container>
</template>

<script>
import { fetchBuild } from "@/api/builds";
import { fetchBuildFile } from "@/api/files";
import { upload,remove } from "@/api/upload";

export default {
  name: "Details",

  components: {
    // AddDeliveryTimeDialog: () => import("./addDeliveryTimeDialog")
  },

  data: () => ({
    snackbar: false,
    text: "",
    timeout: 3000,
    alert: false,
    alert_text: "",
    dialog:false,
   
    action: {
      color: "info",
      icon: "mdi-message-text"
    },
    exportItems: [],
    items: [],
    listQuery: {
      page: 1,
      limit: 10,
      sort: "+id"
    },
    surplus:0,
    search: undefined,
    awaitingSearch: false,
    circle: true,
    disabled: false,
    length: 10,
    nextIcon: "mdi-chevron-right",
    prevIcon: "mdi-chevron-left",
    totalVisible: 10,
    total_pages: 0,
    temp: {
      id: "",
      delivery_time: "",
    },
    files_list:[],
    details:{},
    file:""
  }),

  computed: {
    isAdminRole() {
      // console.log("roles: ", this.$store.getters.roles);
      if (this.$store.getters.roles.includes("administrator")) {
        return true;
      } else {
        return false;
      }
    }
  },

  created() {
    this.getBuilds(this.$route.params.id);
    this.getList();
  },
  watch: {
   
  },
  methods: {
    pickFile() {
      this.$refs.image.click()
    },
    goBack() {
      console.log("goback clicked");
      this.$router.go(-1);
    },
    getQuery() {
      setTimeout(() => this.getList(), 500);
    },
   
    getList() {
      console.log("xxxx");
      this.listLoading = true;
      this.listQuery.limit = 10;
      const id = this.$route.params.id
      fetchBuildFile(id).then(response => {
        this.files_list = response.data;
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },
    getBuilds(id){
      this.listLoading = true;
      fetchBuild(id).then(response => {
        this.details = response.data;
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },
    onFilePicked(e) {
      var files = e.target.files
      const fd = new FormData()
      fd.append('file',files[0])
      upload({id:this.$route.params.id,filetype:3},fd).then(() => {
        this.getList()
      });
    },
    removeFile(id) {
      this.$confirm("确认删除当前文件?").then(res => {
        if (res) {
          remove({id:id}).then(response => {
            // console.log('response: ', response)
            if (response.data.error) {
              this.alert_text = response.data.error;
              this.alert = true;
            } else {
              this.getList();
              // Just to simulate the time of the request
              this.text = "当前文件删除成功！";
              this.snackbar = true;
            }
          });
        }
      });
    },
    paginationChangeHandler(pageNumber) {
      this.listQuery.page = pageNumber;
      this.getList();
    },

    reset() {
      this.$refs.form.reset();
    },

    resetValidation() {
      this.$refs.form.resetValidation();
    },
    
  }
};
</script>

<style scoped>

table,
thead,
th {
  color: rgb(11, 105, 247) !important;
  border-bottom: none;
}

table,
thead,
tr {
  color: #fff;
  font-weight: 400;
  border-bottom: none;
  font-weight: 400;
}
th {
  font-size: 13px !important;
  text-align: right !important;
  color: rgb(255, 255, 255);
  font-weight: 400 !important;
}

td {
  font-size: 13px !important;
  text-align: right !important;
  color: rgb(255, 255, 255);
  font-weight: 400;
}

.fee {
  font-weight: 600 !important;
  color: rgb(15, 126, 201);
}

.total_fee {
  color: rgb(253, 113, 113);
  font-weight: 800;
}

tr:hover {
  background-color: #0282b4 !important;
  color: rgb(224, 221, 221);
}

table { border-collapse:collapse } 
table td, table th {
  height: 50px; 
}

.customer_name {
  color:chocolate;
  font-size:24px;
  margin: 10 0 0 0 !important;
}
.dialog-style {
  background-color: rgb(40, 40, 40) !important;
}
</style>
